import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField, MenuItem, Button } from '@material-ui/core';
import { BASE_URL } from '../../store/config';
import instance from '../../request/http'
import { roleStr, roleName, roleInfo } from '../../common/common';
import Participate from './Participate';
import Toast from '../Layout/components/Toast';

const Root = styled(Box)({
    width: '801px',
    padding: '24px',
    '& .title': {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#005E96',
    },
    '& .title2': {
        fontSize: '14px',
        fontWeight: 'bold',
        marginBottom: '10px',
    },
    '& .textField': {
        width: '100%'
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#F3F3F3',
        margin: '20px 0',
    },
    '& .foot': {
        margin: '10px 0',
        '& .btn': {
            marginRight: '20px',
        },
    },
})

class ShareList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userList: [],
            showToast: false,
            toastMsg: "",
            toastState: "",
        }
        this.handleCreate = this.handleCreate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
    }
    render() {
        const { title } = this.props;
        const {
            showToast,
            toastMsg,
            toastState,
        } = this.state;
        return (
            <Root>
                <div className="title">{title}</div>
                <div className="line"></div>
                <div className="title2">Share Members</div>
                <Participate
                    ref={(child) => { this.participate = child }}
                    userList={this.userFormat()}
                    state={null}
                    addBtnName="Add Share Member"
                />
                <div className="line"></div>
                <div className="foot h h-r">
                    <Button className="btn" variant="contained" onClick={this.handleCancel}>CANCEL</Button>
                    <Button variant="contained" color="primary" onClick={this.handleCreate}>SAVE</Button>
                </div>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
            </Root>
        )
    }
    componentDidMount() {
    }
    handleCreate(e) {
        const { data } = this.props;
        const membersObj = this.participate.getData();
        const client_id = data.id;
        console.log(data)
        console.log(membersObj)
        this.updateMembers(client_id, membersObj, () => {
            this.showToast("Successfully modified", "success");
            this.props.handleSaveShare();
        });
    }
    handleCancel(e) {
        this.props.handleCancel();
    }
    updateMembers(client_id, membersObj, callback) {
        const addMembers = membersObj.addMembers;
        const delMembers = membersObj.delMembers;
        const addIndex = addMembers.length;
        const delIndex = delMembers.length;
        if (addIndex <= 0 && delIndex <= 0) {
            callback();
        } else if (addIndex > 0 && delIndex > 0) {
            this.addMembers(client_id, addMembers, () => {
                this.delMembers(client_id, delMembers, () => {
                    callback();
                });
            });
        } else if (addIndex > 0) {
            this.addMembers(client_id, addMembers, () => {
                callback();
            });
        } else if (delIndex > 0) {
            this.delMembers(client_id, delMembers, () => {
                callback();
            });
        }
    }
    userFormat() {
        const users = this.extractAttorney();
        if (users) {
            let userList = [];
            for (const userObj of users) {
                let obj = {};
                obj.handler_id = userObj.user.id;
                obj.handler_team_id = userObj.team ? userObj.team.id : null;
                obj.is_origin_attorney = userObj.is_origin_attorney;
                userList.push(obj);
            }
            return userList;
        }
        return [];
    }
    extractAttorney() {
        const { data } = this.props;
        console.log(data)
        if (!data) return;
        let participateArr = [];
        const handlerArr = data.handler;
        if (!handlerArr) return null;
        for (const obj of handlerArr) {
            if (!obj.is_origin_attorney) {
                participateArr.push(obj);
            }
        }
        return participateArr;
    }
    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }
    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }
    //-----------request--------------
    addMembers(client_id, handlers, callback) {
        let params = {
            handlers
        }
        instance.post(BASE_URL + roleStr() + '/clients/' + client_id + '/handlers', params).then((res) => {
            callback();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    delMembers(client_id, handlers, callback) {
        let params = {
            handlers
        }
        instance.delete(BASE_URL + roleStr() + '/clients/' + client_id + '/handlers', { data: params }).then((res) => {
            callback();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
}

export default ShareList;